import { Image, Container, Dropdown } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { IMAGES } from "../constants/images";
import { useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useUserRole } from "services/provider";
// import useModal from "hooks/useModal";
import Modals from "./Modals";
import { useAuth } from "../context/UserContext";
import CommonModal from "components/CommonModal";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
const Header = () => {
  const navigate = useNavigate();
  const { setRole } = useUserRole();
  const location = useLocation();
  const [expanded, setExpanded] = useState(false); // State to manage collapse
  const [showModal2, setShowModal2] = useState(false);
  const { setShowFollowers, setFollowTab } = useAuth();
  const handleCloseModal2 = () => {
    setShowModal2(false);
  };

  const navItems = [
    { path: "/software", label: "Software" },
    { path: "/solutions", label: "Solutions" },
    { path: "/resources", label: "Resources" },
    { path: "/vendor", label: "For Vendors" },
    { path: "/about-us", label: "About Us" },
  ];

  const mobileNavItems = [
    { path: "/software", label: "Software" },
    { path: "/solutions", label: "Solutions" },
    { path: "/resources", label: "Resources" },
    { path: "/vendor", label: "For Vendors" },
    { path: "/about-us", label: "About Us" },
  ];

  const mobileUserNavItems = [
    { path: "/my-profile?tab=1", label: "My Reviews" },
    { path: "/my-profile?tab=2", label: "My Favorites" },
    { path: "/my-profile?tab=3", label: "Notifications" },

  ];

  const mobileVendorNavItems = [
    { path: "/vendor/myprofile", label: "Profile Details" },
    { path: "/vendor/products", label: "Products" },
    { path: "/vendor/mysubscription", label: "My Subscription" },
    { path: "/vendor/dispute-management", label: "Dispute Management" },
    { path: "/vendor/my-badges", label: "My Badges" },
    { path: "/vendor/notifications", label: "Notifications" },
  ];

  const [modalType, setModalType] = useState("");
  const [fade, setFade] = useState(false);

  const handleShowModal = (type) => {
    setFade(true);

    setTimeout(() => {
      setModalType(type);
      setFade(false);
    }, 300);
  };

  const handleCloseModal = () => {
    setModalType("");
    setFade(false);
  };

  // get user role
  const { role: defaultRole } = useUserRole();

  // const {user}=useAuth()
  //
  const [showModal1, setShowModal1] = useState(false);

  const handleCloseModal1 = () => {
    setShowModal1(false);
  };

  const { isLoggedIn, logout, user } = useAuth();
  const role = user?.role || defaultRole;
  const handleLogout = () => {
    logout();
    // navigate("/");
    handleCloseModal2();
    setExpanded(false);
  };
  const finalNavItems = useMemo(() => {
    return user
      ? [...mobileNavItems, ...(role === "vendor" ? mobileVendorNavItems : mobileUserNavItems)]
      : mobileNavItems;
  }, [user, role, mobileNavItems, mobileVendorNavItems, mobileUserNavItems]);

  return (
    <>
      <Navbar expand="xl" className="bg-white" expanded={expanded}>
        <Container>
          <div className="d-flex align-items-center w-100 justify-content-between position-relative">
            <Navbar.Brand
              className="cursor-pointer"
              onClick={() => navigate("/")}
            >
              <Image src={IMAGES.Logo} alt="Logo" className="img-fluid" />
            </Navbar.Brand>
            {/* Mobile Close Button - fixed at top right for mobile */}

            <div className="d-flex align-items-center gap-4  ">
            <Nav
              className="ms-auto my-2 my-lg-0 header_profile1 "
              navbarScroll
              onClick={() => setExpanded(false)} // Close when any nav item is clicked
            >
              {navItems?.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                  <Nav.Link
                   
                    key={item.path}
                    to={item.path}
                    as={Link}
                    className={
                      isActive ? "active" : ""
                    }
                  >
                    {item.label}
                  </Nav.Link>
                );
              })}

           
            </Nav>
              <div className="d-flex gap-2   header_profile3">

          

                {(!user || user.role === "user") && (
                  <Button
                    className="me-2 border-radius-100"
                    variant="info"
                    onClick={(e) => {
                      if (!isLoggedIn) {
                        e.preventDefault(); // prevent link navigation
                        toast.error("Please login to write a review", {
                          toastId: "login-required",
                        });
                        return;
                      }

                      // User is logged in, proceed manually
                      localStorage.removeItem("step");
                      localStorage.removeItem("checkedProducts");
                      localStorage.removeItem("verificationId");

                      navigate("/write-a-review");
                      setExpanded(false);
                    }}
                  >
                    Write A Review
                  </Button>
                )}
                <>
                  {isLoggedIn ? (
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="outline-info"
                        id="dropdown-basic"
                        className="d-flex align-items-center gap-2 px-2 py-1 rounded-pill border border-info"
                        style={{
                          backgroundColor: "#fff",
                          color: "#0071E3",
                          fontWeight: "600",
                          fontSize: "16px",
                          borderColor: "#0071E3 !important",
                        }}
                      >
                        <Image
                          src={user?.profileUrl || IMAGES.User2_Img}
                          roundedCircle
                          width={40}
                          height={40}
                          style={{
                            objectFit: "cover",
                          }}
                          alt="User Avatar"
                        />
                        <div
                          style={{
                            maxWidth: "155px",
                            overflow: "hidden",
                            whiteSpace: "nowrap", // Prevents wrapping
                            textOverflow: "ellipsis", // Adds "..." when text is too long
                            padding: "2px",
                          }}
                        >
                          {`${user?.firstName || ""} ${user?.lastName || ""}`
                            .split(" ")
                            .slice(0, 2)
                            .join(" ")}
                        </div>
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item
                          onClick={() => {
                            navigate(
                              role === "vendor"
                                ? "/vendor/myprofile"
                                : "/my-profile?tab=0"
                            );
                            setExpanded(false);
                          }}
                        >
                          My Profile
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            setExpanded(false);
                            setShowModal2(true);
                          }}
                        >
                          Logout
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    <Button
                      variant="outline-info"
                      className="border-radius-100"
                      onClick={() => {
                        setExpanded(false);
                        handleShowModal("login");
                        setRole("user");
                      }} // Close on button click
                    >
                      Join or Log In
                    </Button>
                  )}
                </>
              </div>
              <Navbar.Toggle
                aria-controls="navbarScroll"
                onClick={() => setExpanded(expanded ? false : true)}
              />
            </div>
          </div>

          {/* Mobile overlay for menu */}
        
        {expanded &&
      <>
          <div
         className="mobile-menu-overlay d-xl-none"
         onClick={() => setExpanded(false)}
         style={{
           position: "fixed",
           top: 0,
           left: 0,
           width: "100vw",
           height: "100vh",
         }}
       />
        <Navbar.Collapse
            id="navbarScroll"
            className={`mobile-full-height${
              expanded ? " mobile-menu-open" : ""
            }`}
          >
            <div className="px-3 pt-2 w-100">
              <div className="d-flex align-items-center justify-content-between w-100 mobile-menu-logo">
                <Navbar.Brand
                  className="cursor-pointer "
                  onClick={() => {
                    setExpanded(false)
                    navigate("/")
                  }}
                >
                  <Image src={IMAGES.Logo} alt="Logo" className="img-fluid" />
                </Navbar.Brand>

                <button
                  className="mobile-menu-close-btn d-xl-none"
                  style={{
                    fontSize: "1.3rem",

                    padding: "0.5rem 1rem",
                    cursor: "pointer",
                  }}
                  aria-label="Close menu"
                  onClick={() => setExpanded(false)}
                >
                  ×
                </button>
              </div>
              {user && (
                <>
                  {" "}
                  <div className=" d-flex align-items-center gap-4 justify-content-start mt-4 mb-2 w-100">
                    <Image
                      src={user?.profileUrl || IMAGES.User2_Img}
                      roundedCircle
                      width={70}
                      height={70}
                      style={{
                        objectFit: "cover",
                      }}
                      alt="User Avatar"
                    />
                    <div className="text-center">
                      <h3 className="mb-0" style={{ fontSize: "16px" }}>
                        {user?.followersCount || 0}
                      </h3>
                      <p 
                        onClick={() => {
                          setShowFollowers(true)
                          setFollowTab("Followers")
                          navigate(user?.role === "vendor" ? `/vendor/myprofile` : `/my-profile`)
                         setExpanded(false);
                        }}
                        className="text-muted mb-0"
                        style={{ fontSize: "12px" }}
                      >
                        Followers
                      </p>
                    </div>
                    <div className="text-center">
                      <h3 className="mb-0" style={{ fontSize: "16px" }}>
                        {user?.followingCount || 0}
                      </h3>
                      <p
                       onClick={() => {
                        setShowFollowers(true)
                        setFollowTab("Followers")
                        navigate(user?.role === "vendor" ? `/vendor/myprofile` : `/my-profile`)
                        setExpanded(false);
                      }}
                        className="text-muted mb-0"
                        style={{ fontSize: "12px" }}
                      >
                        Following
                      </p>
                    </div>
                  </div>
                  <div className=" d-flex align-items-center gap-4 justify-content-between mt-4 mb-2 w-100">
                    <div>
                      <h5 className="mb-0">
                        {user?.firstName} {user?.lastName}
                      </h5>
                      <p
                        className="text-muted mb-0"
                        style={{ fontSize: "12px" }}
                      >
                        {user?.email}
                      </p>
                    </div>
                    <Button
                      className="me-2 border-radius-100"
                      variant="info"
                      onClick={(e) => {
                        navigate(role === "vendor" ? "/vendor/myprofile" : "/my-profile");
                        setExpanded(false);
                      }}
                    >
                      View Profile{" "}
                      <Icon
                        icon="solar:arrow-right-linear"
                        fontSize={20}
                        className="ms-2"
                      />
                    </Button>
                  </div>
                </>
              )}
            </div>
            <Nav
              className="ms-auto my-2 my-lg-0 w-100 "
              navbarScroll
              onClick={() => setExpanded(false)} // Close when any nav item is clicked
            >
              {finalNavItems?.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                  <Nav.Link
                    style={{
                      height: "56px ",
                      backgroundColor: isActive && "#f5f5f5",
                    }}
                    key={item.path}
                    to={item.path}
                    as={Link}
                    onClick={() => {
                      setShowFollowers(false)
                    }}
                    className={`px-3 d-flex align-items-center justify-content-between ${
                      isActive ? "active" : ""
                    }`}
                  >
                    {item.label}
                    <Icon icon="solar:arrow-right-linear" fontSize={20} />
                  </Nav.Link>
                );
              })}

              {user && (
                <Nav.Link
                  style={{
                    height: "56px ",
                    // backgroundColor: isActive && "#f5f5f5",
                  }}
                  onClick={() => {
                    setExpanded(false);
                    setShowModal2(true);
                  }}
                  className={`px-3 d-flex align-items-center justify-content-between `}
                >
                  Logout
                  <Icon icon="solar:arrow-right-linear" fontSize={20} />
                </Nav.Link>
                
              )}
            </Nav>
            <div className="d-flex gap-4 justify-content-center w-100 header_profile px-3">
              {(!user || user?.role === "user") && (
                <Button
                  className="border-radius-100 "
                  variant="info"
                  style={{ flex: "1", display: "block" }}
                  onClick={(e) => {
                    if (!isLoggedIn) {
                      e.preventDefault(); // prevent link navigation
                      toast.error("Please login to write a review", {
                        toastId: "login-required",
                      });
                      return;
                    }

                    // User is logged in, proceed manually
                    localStorage.removeItem("step");
                    localStorage.removeItem("checkedProducts");
                    localStorage.removeItem("verificationId");

                    navigate("/write-a-review");
                    setExpanded(false);
                  }}
                >
                  Write A Review
                </Button>
                )}
              {/* <> */}
              {/* {isLoggedIn ? (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="outline-info"
                      id="dropdown-basic"
                      className="d-flex align-items-center gap-2 px-2 py-1 rounded-pill border border-info"
                      style={{
                        backgroundColor: "#fff",
                        color: "#0071E3",
                        fontWeight: "600",
                        fontSize: "16px",
                        borderColor: "#0071E3 !important",
                      }}
                    >
                      <Image
                        src={user?.profileUrl || IMAGES.User2_Img}
                        roundedCircle
                        width={40}
                        height={40}
                        alt="User Avatar"
                      />
                      <div
                        style={{
                          maxWidth: "155px",
                          overflow: "hidden",
                          whiteSpace: "nowrap", // Prevents wrapping
                          textOverflow: "ellipsis", // Adds "..." when text is too long
                          padding: "2px",
                        }}
                      >
                        {`${user?.firstName || ""} ${user?.lastName || ""}`
                          .split(" ")
                          .slice(0, 2)
                          .join(" ")}
                      </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => {
                          navigate(
                            role === "vendor"
                              ? "/vendor/myprofile"
                              : "/my-profile?tab=0"
                          );
                          setExpanded(false);
                        }}
                      >
                        My Profile
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          setExpanded(false);
                          setShowModal2(true);
                        }}
                      >
                        Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                ) : ( */}
              {!user && (
                <Button
                  variant="outline-info"
                  style={{ flex: "1", display: "block" }}
                  className="border-radius-100"
                  onClick={() => {
                    setExpanded(false);
                    handleShowModal("login");
                    setRole("user");
                  }} // Close on button click
                >
                  Join or Log In
                </Button>
              )}
              {/* )} */}
              {/* </> */}
            </div>
          </Navbar.Collapse></>}
        </Container>
      </Navbar>

      <Modals
        {...{
          modalType,
          setModalType,
          fade,
          handleShowModal,
          handleCloseModal,
          showModal1,
          handleCloseModal1,
          role,
          navigate,
        }}
      />

      <CommonModal
        title={"Logout?"}
        para={"Are you sure, You want to logout?"}
        body={
          <div className="btn_Flex">
            <Button
              onClick={handleCloseModal2}
              variant="outline-info"
              className="border-radius-100"
            >
              Cancel
            </Button>
            <Button
              onClick={handleLogout}
              variant="info"
              className="border-radius-100"
            >
              Yes I'm Sure
            </Button>
          </div>
        }
        show={showModal2}
        onClose={handleCloseModal2}
      />
    </>
  );
};

export default Header;
